module.exports = __webpack_public_path__ + "img/115.6d0bd1f2.png";